<template>
	<div class="qwxzs-main">
		<div class="left-menu">
			<div v-for="(item, index) in menuList" :key="index" @click="toPath(index)" class="left-menu-item" :style="{backgroundImage: leftIndex === index ? 'url(../../../static/young_left_select.png)' : ''}">
				<img :src="item.image" >
			</div>
		</div>
		<div class="top-choose-box">
<!-- 			<img class="zswd" src="../../../static/hdyx_left_select.png" v-if="topIndex == 0">
			<img class="zswd" src="../../../static/hdyx_left_unselect.png" v-else @click="topIndex=0">
			<img class="line" src="../../../static/young_line.png" > -->
			<img class="zsgl" src="../../../static/hdyx_right_select.png" v-if="topIndex == 0">
			<!-- <img class="zsgl" src="../../../static/hdyx_right_unselect.png" v-else @click="topIndex=1"> -->
		</div>
		<img class="back_home" @click="backHome" src="../../../static/back_young_home.png" >
		<div v-if="gameSelect === -1" class="game-list-block">
			<div class="game-list-block-left">
				<div class="inner-img" v-if="params.current > 1" @click="changePage(-1)">
					<p>
						前一条
					</p>
				</div>
			</div>
			<div class="game-list-block-middle">
				<div class="game-list-block-middle-item" v-for="(item, index) in gameList" :key="index" @click="openGame">
				<!-- <div class="game-list-block-middle-item" v-for="(item, index) in gameList" :key="index" @click="gameSelect = index"> -->
					<div class="game-list-block-middle-item-top">
						<img :src="$imgUrl + item.listImgPc" >
					</div>
					<div class="game-list-block-middle-item-bottom">
						{{item.title}}
					</div>
				</div>
			</div>
			<div class="game-list-block-right">
				<div class="inner-img" v-if="params.current < pageTotal" @click="changePage(1)">
					<p>
						后一条
					</p>
				</div>
			</div>
		</div>
		<div v-else class="game-details-block">
			<img src="../../../static/back_list.png" class="back" @click="gameSelect = -1">
			<Scroll class="game-details-block-content" :height="300">
				<!-- <iframe src="https://www.hjbwg.mil.cn/storylineOutput/story_html5.html" style="height: 300px;width:100%"></iframe> -->
				<div v-html="gameList[gameSelect].txt" style="color: #FFFFFF; text-align: left; margin-right: 15px;">

				</div>
			</Scroll>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'qwxzs',
		data () {
			return {
				menuList: [
					{
						path: 'qwzs',
						image: '../../../static/qwxzs.png'
					},
					{
						path: 'xxhj',
						image: '../../../static/xxhj.png'
					},
					{
						path: 'kpxjt',
						image: '../../../static/kpxjt.png'
					},
					{
						path: 'zyzs',
						image: '../../../static/zyzs.png'
					},
					{
						path: 'hdyx',
						image: '../../../static/hdyx.png'
					},
				],
				leftIndex: 4,
				topIndex: 0,
				params: {
					current: 1,
					size: 3,
					channelId: 33,
					releaseTerrace: "releasePc"
				},
				pageTotal: 0,
				gameList: [],
				gameSelect: -1
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			this.$store.state.showTop = true
			this.getData()
		},
		methods: {
			openGame() {
				window.open('https://www.hjbwg.mil.cn/storylineOutput/story_html5.html')
			},
			backHome() {
				this.$router.push('young_index')
			},
			toPath(Index) {
				let that = this
				if(Index === 1) {
					this.$Message.info('尚未开放，敬请期待！')
					return
				}
				if(Index != that.leftIndex) {
					that.$router.push(that.menuList[Index].path)
				}
			},
			getData() {
				let that = this
				that.$http.post({
					url: '/api/channel/findContentListByChannelId',
					data: that.params
				}).then(res => {
					if(res.code === 'S200') {
						console.log(res.data.content);
						that.gameList = res.data.content
						that.pageTotal = res.data.pages
					} else {
						that.gameList = []
					}
					that.gameList.forEach(item => {
						item.txt = this.format(item.txt)
					})
				})
			},
			changePage(page) {
				let that = this
				that.params.current += page
				that.getData()
			},
			format(txt) {
				var html = txt
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
				newContent = newContent.replace(/\<img/gi, '<img style="width:550px;height:auto;display:inline-block;margin:10rpx auto;"');
				newContent = newContent.replace(/\<video/gi, '<video style="width:550px;height:auto;display:inline-block;margin:10rpx auto;"');
				return newContent
			}
		}
	}
</script>

<style lang="less" scoped>
	.qwxzs-main {
		margin-top: -33px;
		position: relative;
		width: 100%;
		min-width: 1500px;
		height: 900px;
		background-image: url(../../../static/hdyx_bg.png);
		background-size: 100% 100%;
		z-index: 1000;
		.top-choose-box {
			position: absolute;
			width: 350px;
			height: 106px;
			display: flex;
			justify-content: space-between;
			top: 50px;
			left: calc(50% - 75px);
			z-index: 998;
			.zswd {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
			.line {
				width: 52px;
				height: 2px;
				margin-top: 50px;
			}
			.zsgl {
				width: 140px;
				height: 106px;
				cursor: pointer;
			}
		}
		.bg_4 {
			position: absolute;
			width: 1150px;
			height: 350px;
			top: 227px;
			left: 250px;
			display: flex;
			justify-content: space-between;
			z-index: 997;
			.bg_4_left {
				background-image: url(../../../static/left_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
			.bg_4_middle {
				background-image: url(../../../static/qwxzs_image_4.png);
				background-size: 100% 100%;
				width: 675px;
				height: 386px;
				.bg_4_middle_image {
					width: 167px;
					height: 167px;
					border-radius: 50%;
					position: absolute;
					top: 70px;
					left: 300px;
					img {
						width: 100%;
						height: 100%;
						border-radius: 50%;
					}
				}
				.bg_4_middle_content {
					position: absolute;
					font-size: 13px;
					color: #FFFFFF;
					top: 60px;
					left: 490px;
					width: 330px;
					text-align: left;
				}
				.ckzsd {
					position: absolute;
					top: 180px;
					right: 330px;
					// cursor: pointer;
				}
			}
			.bg_4_right {
				background-image: url(../../../static/right_image.png);
				background-size: 100% 100%;
				height: 233px;
				width: 241px;
				margin-top: 50px;
				color: #2D5AC3;
				font-size: 23px;
				line-height: 180px;
				cursor: pointer;
			}
		}

		.back_home {
			position: absolute;
			width: 102px;
			height: 102px;
			left: 66px;
			bottom: 125px;
			cursor: pointer;
		}
		.left-menu {
			position: absolute;
			width: 170px;
			height: 430px;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			top: 75px;
			left: 55px;
			z-index: 1000;
			.left-menu-item {
				width: 168px;
				height: 65px;
				cursor: pointer;
				text-align: left;
				background-size: 100% 100%;
				img {
					height: 48px;
					margin-top: 9px;
				}
			}
		}

		.game-list-block {
			position: absolute;
			top: 250px;
			left: 19%;
			width: 1200px;
			height: 300px;
			display: flex;
			justify-content: space-between;
			.game-list-block-left {
				height: 233px;
				width: 241px;
				.inner-img {
					width: 100%;
					height: 100%;
					background-image: url(../../../static/left_image.png);
					background-size: 100% 100%;
					cursor: pointer;
					overflow: hidden;
					p {
						margin-top: 70px;
						color: #2D5AC3;
						font-size: 23px;
					}
				}
			}
			.game-list-block-right {
				height: 233px;
				width: 241px;
				.inner-img {
					width: 100%;
					height: 100%;
					background-image: url(../../../static/right_image.png);
					background-size: 100% 100%;
					cursor: pointer;
					overflow: hidden;
					p {
						margin-top: 70px;
						color: #2D5AC3;
						font-size: 23px;
					}
				}
			}
			.game-list-block-middle {
				height: 300px;
				width: 700px;
				display: flex;
				.game-list-block-middle-item {
					height: 300px;
					width: 28%;
					margin: 0 2.6%;
					.game-list-block-middle-item-top {
						background-image: url(../../../static/kpsp_bg.png);
						width: 196px;
						height: 205px;
						background-size: 100% 100%;
						position: relative;
						margin: 0 auto;
						img {
							position: absolute;
							top: 13px;
							left: 5px;
							height: 186px;
							width: 186px;
							border-radius: 50%;
							cursor: pointer;
						}
					}
					.game-list-block-middle-item-bottom {
						margin: 5px auto;
						padding: 0 10px;
						text-align: center;
						font-size: 15px;
						color: #FFFFFF;
						line-height: 30px;
						height: 30px;
						width: 180px;
						border-radius: 8px;
						background: rgba(45, 90, 195, 0.86);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						font-weight: 500;
					}
				}
			}
		}
		.game-details-block {
			position: absolute;
			top: 160px;
			left: 26%;
			width: 800px;
			height: 600px;
			background-image: url(../../../static/game_box.png);
			background-size: 100% 100%;
			.back {
				position: absolute;
				right: 20px;
				top: 30px;
				width: 150px;
				height: 150px;
				cursor: pointer;
			}
			.game-details-block-content {
				width: 600px;
				height: 300px;
				margin: 160px auto 0;
				::-webkit-scrollbar {
					width: 6px;
					background-color: #3582fb;
					border-radius: 10px;
				}
				
				/* 滚动槽 */
				::-webkit-scrollbar-track {
					border-radius: 10px;
				}
				
				::-webkit-scrollbar-thumb {
					background-color: #2a68c9;
					border-radius: 10px;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/young/hdyx.vue